"use client";

import { sizes } from "@/lib/utils/imageSizes";
import clsx from "clsx";
import Image from "next/image";
import { useProductContext } from "../../ProductProvider";
import styles from "./index.module.css";

type Props = {
  className?: string;
};

const ProductPackshots = ({}: Props) => {
  const { activeVariant } = useProductContext();

  const media = activeVariant?.media
    ?.filter(image => image.isPackshot)
    .slice(0, 2);
  return (
    <>
      {media && media?.length > 0 && (
        <div className={styles.packshots} data-layout="page">
          {media?.map((image, i: number) => (
            <div
              className={clsx(styles.packshotImage, styles[`image${i + 1}`])}
              key={i}
            >
              <Image
                src={image.href}
                alt=""
                fill
                className={clsx(styles["image-swiper"])}
                sizes={sizes(100, 50)}
                loading={"eager"}
                quality={90}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};
export default ProductPackshots;
